import Turnstile from 'vue-turnstile';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueTurnstile', Turnstile);
});
